import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b348bf5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-support-cours-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row gx-2" }
const _hoisted_4 = { class: "col-md-10" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Niveau "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Filière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Matière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nombre d'heures "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Auteur", -1))
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Fichier principal (PDF) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_29 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Prérequis", -1))
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Description", -1))
const _hoisted_36 = { class: "col-md-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Image de couverture ", -1))
const _hoisted_38 = { class: "upload-container" }
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 1,
  class: "text-center"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icofont icofont-camera fs-1" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Cliquez pour ajouter l'image", -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icofont icofont-close" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "row mt-4" }
const _hoisted_47 = { class: "col-md-12" }
const _hoisted_48 = { class: "form-check" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fw-semibold",
  for: "estModulaire"
}, " Ce support est modulaire (divisé en plusieurs modules) ", -1))
const _hoisted_50 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_51 = { class: "col-md-12" }
const _hoisted_52 = { class: "border border-primary mb-10" }
const _hoisted_53 = { class: "row d-flex align-items-center justify-content-between fw-bold py-3 bg-primary" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7 ps-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white mb-0" }, "Modules du support")
], -1))
const _hoisted_55 = { class: "col-md-5 pe-4" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-1" }, null, -1))
const _hoisted_57 = { class: "p-4" }
const _hoisted_58 = { class: "row mt-3 align-items-start" }
const _hoisted_59 = { class: "col-md-3" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Code module "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Titre du module "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_63 = { class: "col-md-4" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Fichier du module (PDF) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_65 = ["onChange"]
const _hoisted_66 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_67 = { class: "col-md-1 d-flex align-items-start pt-4" }
const _hoisted_68 = ["onClick", "disabled"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete" }, null, -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { class: "row mt-3" }
const _hoisted_72 = { class: "col-md-12" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Description du module", -1))
const _hoisted_74 = {
  key: 0,
  class: "my-4"
}
const _hoisted_75 = { class: "border border-warning mb-10 mt-10" }
const _hoisted_76 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-warning" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-video me-2" }),
    /*#__PURE__*/_createTextVNode(" Collection de vidéos ")
  ])
], -1))
const _hoisted_78 = { class: "col-md-5" }
const _hoisted_79 = { class: "d-flex float-end" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-1 fs-12" }, null, -1))
const _hoisted_81 = { class: "p-3" }
const _hoisted_82 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_83 = {
  key: 0,
  class: "row mt-10"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
    /*#__PURE__*/_createTextVNode(" Titre de la vidéo "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
  ])
], -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
    /*#__PURE__*/_createTextVNode(" URL / Fichier vidéo "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
  ])
], -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Description")
], -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Action")
], -1))
const _hoisted_88 = [
  _hoisted_84,
  _hoisted_85,
  _hoisted_86,
  _hoisted_87
]
const _hoisted_89 = { class: "row mb-10 align-items-start" }
const _hoisted_90 = { class: "col-md-4" }
const _hoisted_91 = ["onUpdate:modelValue"]
const _hoisted_92 = { class: "col-md-4" }
const _hoisted_93 = { class: "d-flex gap-2 mb-1" }
const _hoisted_94 = { class: "form-check" }
const _hoisted_95 = ["name", "onUpdate:modelValue"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "URL", -1))
const _hoisted_97 = { class: "form-check ms-2" }
const _hoisted_98 = ["name", "onUpdate:modelValue"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "Fichier", -1))
const _hoisted_100 = ["onUpdate:modelValue", "required"]
const _hoisted_101 = { key: 1 }
const _hoisted_102 = ["onChange"]
const _hoisted_103 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_104 = { class: "col-md-3" }
const _hoisted_105 = ["onUpdate:modelValue"]
const _hoisted_106 = { class: "col-md-1 pt-1" }
const _hoisted_107 = ["onClick"]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16",
  class: "text-white"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
  })
], -1))
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = {
  key: 1,
  class: "my-2"
}
const _hoisted_111 = { class: "border border-info mb-10 mt-10" }
const _hoisted_112 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-info" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-alt me-2" }),
    /*#__PURE__*/_createTextVNode(" Collection de textes ")
  ])
], -1))
const _hoisted_114 = { class: "col-md-5" }
const _hoisted_115 = { class: "d-flex float-end" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-1 fs-12" }, null, -1))
const _hoisted_117 = { class: "p-3" }
const _hoisted_118 = {
  key: 0,
  class: "text-center text-muted py-3"
}
const _hoisted_119 = {
  key: 0,
  class: "row mt-10"
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
    /*#__PURE__*/_createTextVNode(" Titre "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
  ])
], -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Type")
], -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
    /*#__PURE__*/_createTextVNode(" Fichier "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
  ])
], -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Action")
], -1))
const _hoisted_124 = [
  _hoisted_120,
  _hoisted_121,
  _hoisted_122,
  _hoisted_123
]
const _hoisted_125 = { class: "row mb-10 align-items-start" }
const _hoisted_126 = { class: "col-md-3" }
const _hoisted_127 = ["onUpdate:modelValue"]
const _hoisted_128 = { class: "col-md-2" }
const _hoisted_129 = ["onUpdate:modelValue"]
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "note" }, "Note", -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "resume" }, "Résumé", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "definition" }, "Définition", -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "exercice" }, "Exercice", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "autre" }, "Autre", -1))
const _hoisted_135 = [
  _hoisted_130,
  _hoisted_131,
  _hoisted_132,
  _hoisted_133,
  _hoisted_134
]
const _hoisted_136 = { class: "col-md-6" }
const _hoisted_137 = ["onChange"]
const _hoisted_138 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_139 = { class: "col-md-1 pt-1" }
const _hoisted_140 = ["onClick"]
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16",
  class: "text-white"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
  })
], -1))
const _hoisted_142 = [
  _hoisted_141
]
const _hoisted_143 = {
  key: 1,
  class: "my-2"
}
const _hoisted_144 = { class: "row mt-5" }
const _hoisted_145 = { class: "col-md-12" }
const _hoisted_146 = { class: "d-flex align-items-center" }
const _hoisted_147 = ["disabled"]
const _hoisted_148 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "supportForm",
        onSubmit: _ctx.addSupportCours,
        onInvalidSubmit: _ctx.handleInvalidSubmit,
        "validation-schema": _ctx.supportSchema,
        validateOnInput: false,
        validateOnMount: false,
        initialValues: {
          nombreHeures: '',
          prerequis: '',
          description: '',
          titre: '',
          auteur: '',
          fichier: null,
          niveau: null,
          filiere: null,
          matiere: null,
          estModulaire: false,
          modulesAdded: []
        }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_Field, {
                      name: "titre",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Titre du support"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "titre",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_Field, { name: "niveau" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.niveauxOptions,
                          searchable: true,
                          "track-by": "value",
                          label: "label"
                        }, field, {
                          onChange: _ctx.onNiveauChange,
                          placeholder: "Sélectionner le niveau",
                          disabled: _ctx.isLoadingAssignments
                        }), null, 16, ["options", "onChange", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "niveau",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_Field, { name: "filiere" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.filieresOptions,
                          searchable: true,
                          "track-by": "value",
                          label: "label"
                        }, field, {
                          onChange: _ctx.onFiliereChange,
                          placeholder: "Sélectionner la filière",
                          disabled: !_ctx.selectedNiveau || _ctx.isLoadingFilieres
                        }), null, 16, ["options", "onChange", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "filiere",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Field, { name: "matiere" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.matieresOptions,
                          searchable: true,
                          "track-by": "value",
                          label: "label"
                        }, field, {
                          placeholder: "Sélectionner la matière",
                          disabled: !_ctx.selectedNiveau || !_ctx.selectedFiliere || _ctx.isLoadingMatieres
                        }), null, 16, ["options", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "matiere",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createVNode(_component_Field, {
                      name: "nombreHeures",
                      type: "number",
                      min: "1",
                      max: "1000",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Ex: 60"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "nombreHeures",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Field, {
                      name: "auteur",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Nom de l'auteur (facultatif)"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "auteur",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_Field, {
                      name: "fichier",
                      type: "file",
                      accept: "application/pdf",
                      onChange: _ctx.onFichierChange,
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, null, 8, ["onChange"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "fichier",
                      class: "text-danger"
                    }),
                    (_ctx.fichierName)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(_ctx.fichierName), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_Field, {
                      name: "prerequis",
                      as: "textarea",
                      rows: "4",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Connaissances requises pour ce cours..."
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "prerequis",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_Field, {
                      name: "description",
                      as: "textarea",
                      rows: "4",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Description détaillée du support de cours..."
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "description",
                      class: "text-danger"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", {
                  class: "preview-card",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                }, [
                  (_ctx.imagePreview)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.imagePreview,
                        alt: "Image preview"
                      }, null, 8, _hoisted_39))
                    : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_43)),
                  (_ctx.imagePreview)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "delete-btn",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                      }, _hoisted_45))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("input", {
                  ref: "fileInput",
                  type: "file",
                  accept: "image/jpeg, image/png, image/jpg, image/webp",
                  hidden: "",
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFilePrinChange && _ctx.onFilePrinChange(...args)))
                }, null, 544),
                _createVNode(_component_ErrorMessage, {
                  name: "urlImage",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_Field, {
                  name: "estModulaire",
                  type: "checkbox"
                }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      type: "checkbox",
                      id: "estModulaire",
                      class: "form-check-input",
                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onEstModulaireChange && _ctx.onEstModulaireChange(...args)))
                    }), null, 16)
                  ]),
                  _: 1
                }),
                _hoisted_49
              ])
            ])
          ]),
          (_ctx.estModulaire)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("button", {
                          class: "btn btn-success float-end",
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addNewModule && _ctx.addNewModule(...args)))
                        }, [
                          _hoisted_56,
                          _createTextVNode(" Ajouter un module ")
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedModules, (module, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: module.tempId
                        }, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _hoisted_60,
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${index}].code`
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                    type: "text",
                                    class: "form-control shadow-none",
                                    placeholder: "Ex: MOD-001",
                                    maxlength: "50"
                                  }), null, 16)
                                ]),
                                _: 2
                              }, 1032, ["name"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `modulesAdded[${index}].code`,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${index}].titre`
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                    type: "text",
                                    class: "form-control shadow-none",
                                    placeholder: "Titre du module"
                                  }), null, 16)
                                ]),
                                _: 2
                              }, 1032, ["name"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `modulesAdded[${index}].titre`,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _hoisted_64,
                              _createElementVNode("input", {
                                type: "file",
                                accept: "application/pdf",
                                onChange: (e) => _ctx.onModuleFichierChange(index, e),
                                class: "form-control shadow-none"
                              }, null, 40, _hoisted_65),
                              (module.fichierName)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_66, _toDisplayString(module.fichierName), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-sm",
                                onClick: ($event: any) => (_ctx.removeModule(index)),
                                disabled: _ctx.addedModules.length === 1
                              }, _hoisted_70, 8, _hoisted_68)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _hoisted_73,
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${index}].description`
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createElementVNode("textarea", _mergeProps({ ref_for: true }, field, {
                                    class: "form-control shadow-none",
                                    rows: "3",
                                    placeholder: "Description optionnelle du module..."
                                  }), null, 16)
                                ]),
                                _: 2
                              }, 1032, ["name"])
                            ])
                          ]),
                          (index < _ctx.addedModules.length - 1)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_74))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _hoisted_77,
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("button", {
                    class: "btn btn-light",
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addVideo && _ctx.addVideo(...args)))
                  }, [
                    _hoisted_80,
                    _createTextVNode(" Ajouter une vidéo ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              (_ctx.videos.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_82, " Aucune vidéo ajoutée. Cliquez sur \"Ajouter une vidéo\" pour commencer. "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, _hoisted_88))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Ex: Introduction au chapitre 1",
                        "onUpdate:modelValue": ($event: any) => ((video.titre) = $event)
                      }, null, 8, _hoisted_91), [
                        [_vModelText, video.titre]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: `videoSource_${index}`,
                            value: "url",
                            "onUpdate:modelValue": ($event: any) => ((video.sourceType) = $event)
                          }, null, 8, _hoisted_95), [
                            [_vModelRadio, video.sourceType]
                          ]),
                          _hoisted_96
                        ]),
                        _createElementVNode("div", _hoisted_97, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: `videoSource_${index}`,
                            value: "fichier",
                            "onUpdate:modelValue": ($event: any) => ((video.sourceType) = $event)
                          }, null, 8, _hoisted_98), [
                            [_vModelRadio, video.sourceType]
                          ]),
                          _hoisted_99
                        ])
                      ]),
                      (video.sourceType === 'url')
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "url",
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "https://youtube.com/...",
                            "onUpdate:modelValue": ($event: any) => ((video.url) = $event),
                            required: video.sourceType === 'url'
                          }, null, 8, _hoisted_100)), [
                            [_vModelText, video.url]
                          ])
                        : (_openBlock(), _createElementBlock("div", _hoisted_101, [
                            _createElementVNode("input", {
                              type: "file",
                              accept: "video/*",
                              class: "form-control shadow-none fs-md-15 text-black",
                              onChange: (e) => _ctx.onVideoFichierChange(index, e)
                            }, null, 40, _hoisted_102),
                            (video.fichierName)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_103, _toDisplayString(video.fichierName), 1))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control shadow-none fs-md-15 text-black",
                        rows: "2",
                        placeholder: "Description courte (optionnel)",
                        "onUpdate:modelValue": ($event: any) => ((video.description) = $event)
                      }, null, 8, _hoisted_105), [
                        [_vModelText, video.description]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("button", {
                        class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeVideo(index))
                      }, _hoisted_109, 8, _hoisted_107)
                    ])
                  ]),
                  (index < _ctx.videos.length - 1)
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_110))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("div", _hoisted_112, [
              _hoisted_113,
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("button", {
                    class: "btn btn-light",
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addTexte && _ctx.addTexte(...args)))
                  }, [
                    _hoisted_116,
                    _createTextVNode(" Ajouter un texte ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_117, [
              (_ctx.textes.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_118, " Aucun texte ajouté. Cliquez sur \"Ajouter un texte\" pour commencer. "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textes, (texte, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_119, _hoisted_124))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("div", _hoisted_126, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Ex: Résumé du chapitre 1",
                        "onUpdate:modelValue": ($event: any) => ((texte.titre) = $event)
                      }, null, 8, _hoisted_127), [
                        [_vModelText, texte.titre]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_128, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select shadow-none fs-md-15 text-black",
                        "onUpdate:modelValue": ($event: any) => ((texte.type) = $event)
                      }, _hoisted_135, 8, _hoisted_129), [
                        [_vModelSelect, texte.type]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("input", {
                        type: "file",
                        class: "form-control shadow-none fs-md-15 text-black",
                        accept: ".pdf,.doc,.docx,.txt",
                        onChange: ($event: any) => (_ctx.handleTexteFileUpload($event, index))
                      }, null, 40, _hoisted_137),
                      (texte.fichierName)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_138, _toDisplayString(texte.fichierName), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_139, [
                      _createElementVNode("button", {
                        class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeTexte(index))
                      }, _hoisted_142, 8, _hoisted_140)
                    ])
                  ]),
                  (index < _ctx.textes.length - 1)
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_143))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_144, [
            _createElementVNode("div", _hoisted_145, [
              _createElementVNode("div", _hoisted_146, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  disabled: _ctx.isSubmitting
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_148))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Création en cours...' : 'Créer le support de cours'), 1)
                ], 8, _hoisted_147),
                _createVNode(_component_router_link, {
                  to: "/liste-support",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_149,
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "onInvalidSubmit", "validation-schema"])
    ])
  ]))
}